export default "__VITE_ASSET__2yXwqSEE__"